<template>
	<div class="grid max-w-3xl gap-8 px-8 py-12 mx-auto">
		<h2>
			{{ $t('acceptable-use-policy.title') }}
		</h2>
		<div
			class="prose-lg text-highlighted break-words"
			v-html="$t('acceptable-use-policy.copy', { LEGAL_NAME })"
		/>
	</div>
</template>

<script setup>
import { LEGAL_NAME } from '@/constants/index'

definePageMeta({
	layout: 'blank'
})
</script>
